module.exports = __webpack_public_path__ + "img/organizate.a8a3faa5.png";